export default __webpack_public_path__ + "static/media/azavea-logo.5ede3a81.svg";